import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStar = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "m14.8 8.625 7.2.625-5.45 4.725L18.175 21 12 17.275 5.825 21l1.625-7.025L2 9.25l7.2-.625L12 2zM10.55 10.5l-3.65.325 2.775 2.425-.825 3.575 3.15-1.9 3.15 1.925-.825-3.6 2.775-2.4-3.65-.325-1.45-3.4z" })
});
export default SvgStar;
